import { gql } from '@apollo/client';

export const GET_CSVFILE_COLUMNS = gql`
  query GetCSVFileColumns($input: CSVFileInput!) {
    csvFileColumns: getCSVFileColumns(input: $input) {
      id
      index
      name
    }
  }
`;
